<template>
    <jet-action-section>
        <template #title>
            Two Factor Authentication
        </template>

        <template #description>
            Add additional security to your account using two factor authentication.
        </template>

        <template #content>
            <h3 class="text-lg font-medium text-gray-900" v-if="twoFactorConfirmed">
                You have enabled two factor authentication.
            </h3>

            <h3 class="text-lg font-medium text-gray-900" v-else>
                You have not enabled two factor authentication.
            </h3>

            <div class="mt-3 max-w-xl text-sm text-gray-600">
                <p>
                    When two factor authentication is enabled, you will be prompted for a secure, random token during
                    authentication. This token will be sent to your phone via SMS.
                </p>
            </div>
            <div class="mt-4" v-if="!showConfirmation">
                <label class="block font-medium text-sm text-gray-700" for="mobile_phone">Cell Phone Number</label>
                <v-text-field id="mobile_phone" type="text" class="form-input rounded-md shadow-sm mt-1 block w-full"
                              v-model="enableForm.mobilePhone"></v-text-field>
            </div>

            <div v-if="showConfirmation">
                <div class="mt-4">
                    <label class="block font-medium text-sm text-gray-700" for="code">Code</label>
                    <v-text-field id="code" type="text" class="form-input rounded-md shadow-sm mt-1 block w-full"
                                  v-model="twoFactorCode"></v-text-field>
                </div>

                <jet-confirms-password @confirmed="confirmTwoFactorAuthentication">
                    <jet-button type="button" :class="{ 'opacity-25': enabling }" :disabled="enabling">
                        Validate 2FA
                    </jet-button>
                </jet-confirms-password>
            </div>

            <div class="mt-5" v-if="!twoFactorConfirmed && !showConfirmation">
                <div>
                    <jet-confirms-password @confirmed="enableTwoFactorAuthentication">
                        <jet-button type="button" :class="{ 'opacity-25': enabling }" :disabled="enabling">
                            Enable
                        </jet-button>
                    </jet-confirms-password>
                </div>
            </div>

            <div class="mt-5" v-else-if="twoFactorConfirmed">
                <jet-confirms-password @confirmed="disableTwoFactorAuthentication">
                    <jet-danger-button
                        :class="{ 'opacity-25': disabling }"
                        :disabled="disabling">
                        Disable
                    </jet-danger-button>
                </jet-confirms-password>
            </div>
        </template>
    </jet-action-section>
</template>

<script>
import JetActionSection from '@/Jetstream/ActionSection'
import JetButton from '@/Jetstream/Button'
import JetConfirmsPassword from '@/Jetstream/ConfirmsPassword'
import JetDangerButton from '@/Jetstream/DangerButton'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'

export default {
    components: {
        JetActionSection,
        JetButton,
        JetConfirmsPassword,
        JetDangerButton,
        JetSecondaryButton,
    },

    data() {
        return {
            enabling: false,
            disabling: false,

            showConfirmation: false,
            twoFactorCode: null,
            enableForm: {
                mobilePhone: this.$page.user.mobile_phone,
            },
        }
    },

    methods: {
        enableTwoFactorAuthentication() {
            if(this.enableForm.mobilePhone !== null) {
                this.enabling = true

                this.$inertia.post('/user/two-factor-authentication', this.enableForm,
                    {
                        preserveScroll: true,
                    }).then(() => {
                    return Promise.all([
                        this.showConfirmation = true
                    ])
                }).then(() => {
                    this.enabling = false
                })
            } else {
                this.$root.snackbar.error('Please enter your cell phone number')
            }
        },

        confirmTwoFactorAuthentication() {
            axios.post('/2fa-confirm', {code: this.twoFactorCode})
                .then(response => {
                    if(response.data.confirmed) {
                        this.$page.user.two_factor_confirmed = response.data.confirmed
                        this.$page.user.mobile_phone = this.enableForm.mobilePhone
                        this.showConfirmation = false
                    } else {
                        this.$root.snackbar.error('Could not confirm your phone number')
                    }
                })
        },

        disableTwoFactorAuthentication() {
            this.disabling = true

            this.$inertia.delete('/user/two-factor-authentication', {
                preserveScroll: true,
            }).then(() => {
                this.disabling = false
                this.$page.user.two_factor_confirmed = false;
            })
        },
    },

    computed: {
        twoFactorConfirmed() {
            return !!this.$page.user.two_factor_confirmed
        }
    }
}
</script>
